import { Chip } from '@mui/material';
import { GetModelStatusResponse } from 'api/ml-service/ml-service.types';
import { useTranslation } from 'react-i18next';

type RecommendationsSettingsStatusChipProps = {
  status: GetModelStatusResponse['modelReady'];
};

const RecommendationsSettingsStatusChip = ({
  status,
}: RecommendationsSettingsStatusChipProps) => {
  const { t } = useTranslation();
  let color, label;
  switch (status) {
    case 1:
      color = 'success';
      label = t('page.menus.recommendations.settings.modelStatus.ready.label');
      break;
    case 0:
      color = 'info';
      label = t(
        'page.menus.recommendations.settings.modelStatus.inProgress.label',
      );
      break;
  }

  return (
    <Chip
      color={color}
      label={label}
      data-testid="RecommendationsSettingsStatusChip"
    />
  );
};

export default RecommendationsSettingsStatusChip;
